
import { Button, Checkbox, Divider, Group, Input, SegmentedControl, Select, Stack, Textarea } from '@mantine/core';
import { useForm } from '@mantine/form';
import { useDisclosure } from '@mantine/hooks';
import { FormInputWrapper } from 'core/components/';

import { useEffect, useRef, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { AppConstants, CompanyFormats, shotChannels } from 'utils/constants';
import { logger } from 'utils/logger';
import CustomDatePicker from 'core/components/datePicker/CustomDatePicker';
import moment from 'moment';

import { updateSample, updateSampleSuccess, clearNotifications } from 'modules/Warehouse/warehouseSlice';
import { getClientLabel, getCompany } from 'utils/helper';

const LABEL_WIDTH = 180;
const SampleEdit = ({ sample, onCancel, createAnotherFlag=false, onSampleSave, aggData, season, departments, success, onPrefChange=()=>{} }) => {
    const [active, handlers] = useDisclosure(false);
    const [isSaving, setIsSaving] = useState(false);
    const codeRef = useRef(null);
    // const [doCreateAnother, setDoCreateAnother] = useState(createAnotherFlag)
    const dispatch = useDispatch();

    const form = useForm({
        initialValues: {
            photoCode: '',
            styleCode: '',
            name: '',
            notes: '',
            size: '',
            department: '',
            otbDate: '',
            multiShotFlag: '',
            outfittingFlag: '',
            channels: season.channels ? season.channels : [], // default to season channels if not set.
        },

        validate: {
            photoCode: (value) => (value.length ? null : 'Invalid Photo Code'),
            styleCode: (value) => (value.length ? null : 'Invalid Style Code'),
            name: (value) => (value.length ? null : 'Invalid Name'),
        },
    });

    useEffect(() => {
        if (success) {
            switch (success.type) {
                case updateSampleSuccess.toString(): {
                    onSampleSave();
                    dispatch(clearNotifications());
                    setIsSaving(false)
                    // if we are creating a new one clear the values.
                    if(createAnotherFlag){
                        form.setValues({
                            photoCode: '',
                            styleCode: '',
                            name: '',
                            notes: '',
                            size: '',
                            department: '',
                            otbDate: null,
                            multiShotFlag: '',
                            outfittingFlag: '',
                        })

                        setTimeout(() => {
                            codeRef.current.focus()
                        }, 1000);
                    }
                   
                    break;
                }
                default: {
                    break;
                }
            }
        }
    }, [success]);

    useEffect(() => {
        if (!active) {
            logger.log('toggling focus ');
            setTimeout(() => {
                handlers.toggle();
            }, 1000);
        }
    }, [active, handlers]);

    /**
     * Function to submit values to create a new sample
     * @param {*} values
     */
    const formHandler = (values) => {
        setIsSaving(true);
        // we need to update a selectedTask.
        const deadline = moment(values.otbDate).format('YYYY-MM-DD');

        // var payload = new SampleModel({
        //     ...values,
        //     deadline: deadline,
        // });

        // if (mode === ViewModes.ADD) {
        //     delete payload.id;
        // }

        // we add the department
        const payload = { ...values, Dept: values.department, channels: values.channels.join(',') };
        dispatch(updateSample(season, payload));

    };
    const company = getCompany(aggData);

    return (
        <>
            <form onSubmit={form.onSubmit((values) => formHandler(values))}>
                {/* <FocusTrap active={true}> */}
                <FormInputWrapper labelWidth={LABEL_WIDTH} required label='Photo Code' id='input-photoCode'>
                    <Input ref={codeRef} id='input-photoCode' required placeholder='Enter Photo Code' data-autofocus variant={AppConstants.inputVariant} {...form.getInputProps('photoCode')} />
                </FormInputWrapper>

                <FormInputWrapper labelWidth={LABEL_WIDTH} required label={CompanyFormats[company.code].LABELS.style} id='input-style'>
                    <Input id='input-style' required placeholder={`Enter ${CompanyFormats[company.code].LABELS.style}`} variant={AppConstants.inputVariant} {...form.getInputProps('styleCode')} />
                </FormInputWrapper>

                <FormInputWrapper labelWidth={LABEL_WIDTH} required label={CompanyFormats[company.code].LABELS.name} id='input-name'>
                    <Input id='input-name' required placeholder={`Enter ${CompanyFormats[company.code].LABELS.name}`} variant={AppConstants.inputVariant} {...form.getInputProps('name')} />
                </FormInputWrapper>

                <FormInputWrapper labelWidth={LABEL_WIDTH} label='Notes' id='input-notes'>
                    <Textarea id='input-notes' placeholder='Notes' variant={AppConstants.inputVariant} {...form.getInputProps('notes')} />
                </FormInputWrapper>

                <FormInputWrapper labelWidth={LABEL_WIDTH} label='Sample size' id='input-sampleSize'>
                    <Input id='input-sampleSize' placeholder='Enter Sample Size' variant={AppConstants.inputVariant} {...form.getInputProps('size')} />
                </FormInputWrapper>

                <FormInputWrapper labelWidth={LABEL_WIDTH} label='Department' id='input-department'>
                    <Select searchable data={departments?.map(val => ({value:val.code, label:`${val.code} - ${val.name}`}))} id='input-department' placeholder='Enter Department' variant={AppConstants.inputVariant} {...form.getInputProps('department')} />
                </FormInputWrapper>

                <FormInputWrapper labelWidth={LABEL_WIDTH} label={getClientLabel(company, 'otbDate')} id='input-otbDate'>
                    <CustomDatePicker placeholder={getClientLabel(company, 'otbDate')} {...form.getInputProps('otbDate')} />
                </FormInputWrapper>

                <FormInputWrapper labelWidth={LABEL_WIDTH} label='Sample Identifier' id='input-identifier'>
                    <Input placeholder='Enter Sample Identifier' variant={AppConstants.inputVariant} {...form.getInputProps('sampleIdentifier')} />
                </FormInputWrapper>

                <FormInputWrapper labelWidth={LABEL_WIDTH} label='Style Number' id='input-identifier'>
                    <Input placeholder='Enter Style Number' variant={AppConstants.inputVariant} {...form.getInputProps('stylenumber')} />
                </FormInputWrapper>

                <FormInputWrapper labelWidth={LABEL_WIDTH} label='Barcode' id='input-barcode'>
                    <Input placeholder='Enter Barcode' variant={AppConstants.inputVariant} {...form.getInputProps('barcode')} />
                </FormInputWrapper>
                <Divider />
                <FormInputWrapper label='Multi Shot' labelWidth={LABEL_WIDTH} description='Multi Shot includes both Talent and Flatlay shot'>
                    {/* <Checkbox {...form.getInputProps('multiShotFlag')}/> */}
                    <SegmentedControl
                        sx={{ width: '100%' }}
                        data={[
                            { label: 'Single Shot', value: '' },
                            { label: 'Multi Shot', value: 'Y' },
                        ]}
                        // placeholder='PSD Loaded'
                        {...form.getInputProps('multiShotFlag')}
                    />
                </FormInputWrapper>
                <Divider />
                
                <FormInputWrapper label='Outfitting Available' labelWidth={LABEL_WIDTH} description='Are the correct styles available for styling?'>
                    <SegmentedControl
                        sx={{ width: '100%' }}
                        data={[
                            { label: 'Yes', value: 'Y' },
                            { label: 'No', value: '' },
                        ]}
                        // placeholder='PSD Loaded'
                        {...form.getInputProps('outfittingFlag')}
                    />
                </FormInputWrapper>
                
                <Divider />
                <FormInputWrapper label='Channels' labelWidth={180} id='input-channels' description='Select the channels for the Event'>
                    <Stack spacing='xs' mt={4}>
                        {shotChannels.map((channel, index) => (
                            <Checkbox
                                key={index}
                                label={channel.label}
                                value={channel.value}
                                checked={form.values.channels?.includes(channel.value) || false}
                                onChange={(event) => {
                                    const currentChannels = form.values.channels || [];
                                    if (event.currentTarget.checked) {
                                        form.setFieldValue('channels', [...currentChannels, channel.value]);
                                    } else {
                                        form.setFieldValue(
                                            'channels',
                                            currentChannels.filter((c) => c !== channel.value),
                                        );
                                    }
                                }}
                            />
                        ))}
                    </Stack>
                </FormInputWrapper>
                <Divider />

                {/* <FormInputWrapper label='Season' id='input-season'>
                <Select
                    data={seasonData}
                    placeholder="Select Season"
                    nothingFound="Nothing found"
                    searchable
                    creatable
                    getCreateLabel={(query) => `+ Create ${query}`}
                    onCreate={(query) => {
                      const item = { value: query, label: query };
                      setSeasonData((current) => [...current, item]);
                      return item;
                    }}
                  />
                </FormInputWrapper>


                <FormInputWrapper label='Tags' id='input-tags'>
                <Input id='input-tags'
                    placeholder="Tags" variant={AppConstants.inputVariant}
                />
                </FormInputWrapper>

                <FormInputWrapper label='Hero CAD' id='input-desc' description='Upload the CAD file for this sample. CAD file should be of type SVG.'>
                <SampleDropzone></SampleDropzone>
                </FormInputWrapper>       */}

                <Group position='apart' mt='md'>
                    <Checkbox checked={createAnotherFlag} onChange={(e) => {
                        logger.log("prefschange:",e.target.checked)
                        // setDoCreateAnother(e.target.checked)
                        onPrefChange(e.target.checked);
                    }} label="Create Another"/>

                    <Button type='submit' loading={isSaving}>
                        Create Style
                    </Button>
                    
                </Group>
                {/* </FocusTrap> */}
            </form>
        </>
    );
};

const mapStateToProps = (state, props) => {
    //logger.log(state,props, ' mapstate')
    return {
        user: state.auth.user,
        sample: state.warehouse.selectedSample,
        departments: state.appReducer.departments,
        aggData: state.appReducer.aggData,
        success: state.warehouse.success,
        error: state.warehouse.error,
    };
};

const mapDispatch = {};

export default connect(mapStateToProps, mapDispatch)(SampleEdit);
